// extracted by mini-css-extract-plugin
export default {"imageWrapper":"XD-z","hovered":"YD-z","hoverImage":"ZD-z","mainImage":"_D-z","imageNoBackground":"aE-z","fullSizeImage":"bE-z"};